import CheckIcon from "@mui/icons-material/Check";

export const ResetPasswordInstructionsSentScreen = () => {
  return (
    <div className="flex flex-col w-full min-h-screen px-8 pl-36 justify-center">
      <div className="flex flex-col max-w-lg gap-8">
        <div className="bg-faux-mountain-meadow flex justify-center items-center rounded-full h-16 w-16 text-white">
          <CheckIcon fontSize="large" />
        </div>
        <div>
          <h1 className="text-white text-3xl font-semibold font-orbitron">
            Enviamos las instrucciones
          </h1>
          <p className="text-white text-xl font-inter">
            Chequea tu casilla de correo.
          </p>
        </div>
        <p className="text-white text-xl font-inter">
          No recibiste un correo? Chequea tu Spam o Contacta a tu vendedor
        </p>
      </div>
    </div>
  );
};
